import { IconNotification } from '@justeattakeaway/pie-icons-react';
import { PIEIconButton, PIEIconButtonModes } from '@src/shared/components/PIEIconButton';
import { Badge } from 'snacks-design-system';
import React from 'react';
import styles from './HeaderNotificationIndicator.module.scss';

interface componentProps {
  loading: boolean;
  onClick?: () => void;
  counter: number;
}

const HeaderNotificationIndicator = ({ loading, onClick, counter }: componentProps) => {
  return (
    <div className={styles.HeaderNotificationIndicator}>
      <PIEIconButton
        isLoading={loading}
        onClick={onClick}
        icon={<IconNotification size="l" />}
        mode={PIEIconButtonModes.GHOST_TERTIARY}
      />
      {counter > 0 && (
        <Badge mode="brand" align="t-l">
          {counter}
        </Badge>
      )}
    </div>
  );
};

export default HeaderNotificationIndicator;
